import {ModuleRouteManifest} from '../types'

export const assessmentRouteManifest: ModuleRouteManifest = {
  code: 'assessment',
  privateRoutes: [
    'createexam',
    'my-course-exam/manual',
    'manual-exams/measurement-center',
    'e-exam/:examSeatAssignmentId',
    'studentlist',
    'exam-optical-reading',
    'question-requests/incoming',
    'courseoutcomesreport',
    'my-course-outcome',
    'surveyresult',
    'my-course/*',
    'my-course-exam/*',
    'my-boardmodule/*',
    'boardschedule/*',
    'exam/*',
    'examquestion/*',
    'questionbank/*',
    'learningobjectivequestion/*',
    'questionitem/*',
    'questiontype/*',
    'examtype/*',
  ],
}
